/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_EmptyInputs */

const en_task_reminders_empty = /** @type {(inputs: Task_Reminders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reminders yet.`)
};

const pt_br2_task_reminders_empty = /** @type {(inputs: Task_Reminders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum lembrete ainda.`)
};

/**
* | output |
* | --- |
* | "No reminders yet." |
*
* @param {Task_Reminders_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_empty = /** @type {((inputs?: Task_Reminders_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_empty(inputs)
	return pt_br2_task_reminders_empty(inputs)
});